// extracted by mini-css-extract-plugin
export default {"root":"PlayerList_root__n47xy","bg":"PlayerList_bg__nEEPA","table":"PlayerList_table__wh6Kq"};